import React from "react"

export const ButtonGroup = (props) => {
  const { className = "", style } = props
  return (
    <div className={`button-group ${className}`} style={style}>
      {props.children}
    </div>
  )
}

export const FormGroup = (props) => {
  const { className = "", style } = props
  return (
    <div className={`form-group ${className}`} style={style}>
      {props.children}
    </div>
  )
}
